import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../../../../app/store";
import EmailEditorModel from "../../../../EmailEditorModal/models/EmailEditorModel";

interface SupportSheetHelpTextState {
    title: string,
    helperText: string,
    showInput: boolean,
    emailSendAfterAgree: EmailEditorModel,
    showEmailAfterOk: boolean
}

const initialState: SupportSheetHelpTextState = {
    title: "",
    helperText: "",
    showInput: false,
    emailSendAfterAgree: {

    } as EmailEditorModel,
    showEmailAfterOk: false
}

export const SupportSheetHelpTextSlice = createSlice({
    name: "SupportSheetHelpText",
    initialState,
    reducers: {
        setTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload;
        },
        setHelperText: (state, action: PayloadAction<string>) => {
            state.helperText = action.payload;
        },
        setShowHelperTextModal: (state, action: PayloadAction<boolean>) => {
            state.showInput = action.payload;
        },
        setEmailSendAfterAgree: (state, action: PayloadAction<EmailEditorModel>) => {
            state.emailSendAfterAgree = action.payload;
        },
        setShowEmailAfterOk: (state, action: PayloadAction<boolean>) => {
            state.showEmailAfterOk = action.payload;
        },
    }
});

export const SupportSheetHelpTextSelector = createSelector(
    (state: RootState) => state.supportSheetHelperText,
    (data) => data
);

export const {
    setTitle,
    setHelperText,
    setShowHelperTextModal,
    setEmailSendAfterAgree,
    setShowEmailAfterOk
} = SupportSheetHelpTextSlice.actions;

export default SupportSheetHelpTextSlice.reducer;